/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { Link, V2ChevronLeftIcon, V2ChevronRightIcon } from '@paypalcorp/pp-react';
import getHistory from '../../lib/HistoryHelper';
import { trackLink } from '../../lib/analytics-helper';
import { FAQ_ARTICLE } from '../../contactUs/constants/PropTypesShapes';
import Page from '../../lib/page';
import { redirectToHomePage } from '../../../jsV2/helpers/globalHelper';
import UrlResources from '../constants/UrlResources';

const directMapping = {
  ltr: 'right',
  rtl: 'left',
};

const Breadcrumb = function (props) {
  const { items, action } = props;
  const history = getHistory();

  const push = (element, key, updateBreadcrumb) => {
    const breadcrumb = items.slice(0, key + 1);
    if (updateBreadcrumb) {
      updateBreadcrumb(breadcrumb);
    }

    const FPTIId = Page.getFPTIPageId(); // Bread Crumb is Used for both Topic and article page
    trackLink({ id: FPTIId, link: `smarthelp-hcr-breadcrumb|${element.title}` });

    if (element.path === `/${UrlResources.HOME}`) {
      return redirectToHomePage();
    }
    return history.push(`${element.path}`);
  };

  const handleKeyPress = (event, item, key, actions) => {
    if (event.which === 13) {
      push(item, key, actions);
    }
  };

  // Update breadcrumb arrow style by wwebpage direction
  const arrowIcon = (key) => {
    const direction = directMapping[Page.getDirection()];
    if (key !== items.length - 1) {
      if (direction === 'right') {
        return <V2ChevronRightIcon size="xs" className="icon-cheveron-breadcrumb" />;
      }
      if (direction === 'left') {
        <V2ChevronLeftIcon size="xs" className="icon-cheveron-breadcrumb" />;
      }
    }
    return '';
  };

  const renderBreadCrumb = () => {
    const itemList = items.map((item, key) => {
      const attrs = {
        className: 'breadcrumb-item-content',
        href: `/${Page.getCountry()}/smarthelp${item.path}`,
        onClick: (e) => {
          e.preventDefault();
          push(item, key, action);
        },
        onKeyPress: (e) => handleKeyPress(e, item, key, action),
        theme: 'v2',
        primaryAlt: key === items.length - 1,
      };

      if (key === items.length - 1) {
        // Adding aria-current for the last breadcrumb link based on https://www.w3.org/TR/wai-aria-practices/#breadcrumb
        attrs['aria-current'] = 'page';
      }

      return (
        <li className="breadcrumb-item" key={item.title}>
          <Link {...attrs}>
            <span
              className={key === items.length - 1 ? 'article-breadcrumb-selected-title' : 'article-breadcrumb-title'}
            >
              {item.title}
            </span>
          </Link>
          {arrowIcon(key)}
        </li>
      );
    });

    return <ul className="article-breadcrumb-path">{itemList}</ul>;
  };

  return (
    <div className="article-breadcrumb" role="navigation" aria-label="Breadcrumb">
      {renderBreadCrumb()}
    </div>
  );
};

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(FAQ_ARTICLE)),
  action: PropTypes.func,
};
Breadcrumb.defaultProps = {
  items: [],
  action: undefined,
};

export default Breadcrumb;
